<template>
  <div class="news-item">
    <div class="news-item__title">
      <div class="rt-container">
        <div class="rt-col">
          <div class="row">
            <div class="rt-col-8 rt-col-td-6">
              <h2 class="font-h2 sp-t-5 sp-b-3 td-sp-t-3 md-sp-t-2 md-sp-b-1-3 color-dark-blue">{{ content.title }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="news-item__content sp-t-3 sp-b-5 td-sp-b-2 md-sp-t-1-3 md-sp-b-1-2">
      <div class="rt-container">
        <div class="rt-col">
          <div class="row">
            <div class="rt-col-8 rt-col-td-6">
              <div class="news-item__wrapper color-main085" v-html="content.content" :class="{'news-item__wrapper--hidden' : Object.keys(content).length === 0}"/>
            </div>
            <div class="rt-col-1 td-d-none"/>
            <div class="rt-col-3 rt-col-td-6">
              <div class="sticky td-sp-t-2 row">
                <div class="rt-col-percent-10 rt-col-td-3 rt-col-md-3 sp-b-1 md-sp-b-0-3" v-for="card in additionalNews">
                  <NewsCard :data="card.attributes"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="news-item__navigation">
      <div class="rt-container">
        <div class="rt-col">
          <div class="row">
            <div class="rt-col-6 rt-col-md-3">
              <NuxtLink class="sp-v-3 md-sp-v-1 d-flex nav-button" v-show="!isFirst" :to="sortedNewsContent[index - 1]?.attributes.slug">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M6.81731 12.749L11.0289 16.9388L9.97105 18.0022L4.47105 12.5307C4.32955 12.39 4.25 12.1986 4.25 11.999C4.25 11.7994 4.32955 11.6081 4.47105 11.4673L9.97105 5.99585L11.0289 7.05926L6.81737 11.249L20 11.249L20 12.749L6.81731 12.749Z" fill="#7B939B"/>
                </svg>
                <span class="sp-l-0-3 color-slate font-h4 md-sp-h-none">Предыдущая новость</span>
              </NuxtLink>
            </div>
            <div class="rt-col-6 rt-col-md-3">
              <NuxtLink class="sp-v-3 md-sp-v-1 d-flex nav-button jc-fe" v-show="!isLast" :to="sortedNewsContent[index + 1]?.attributes.slug">
                <span class="sp-r-0-3 color-slate font-h4 md-sp-h-none">Следующая новость</span>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M17.1827 12.749L12.9711 16.9388L14.029 18.0022L19.5289 12.5307C19.6704 12.39 19.75 12.1986 19.75 11.999C19.75 11.7994 19.6704 11.6081 19.5289 11.4673L14.0289 5.99585L12.9711 7.05926L17.1826 11.249L4 11.249L4 12.749L17.1827 12.749Z" fill="#7B939B"/>
                </svg>
              </NuxtLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {newsItemQuery, newsQuery} from '~/graphql/newsQuery'
import TextField from "~/components/commonUi/TextField.vue"
export default {
  components: {TextField},
  data() {
    return {
      content: {},
      sortedNewsContent: [],
      additionalNews: [],
      index: -1,
      isFirst: false,
      isLast: false
    }
  },
  mounted() {
    this.getData()
    this.getAllNews()

    useHead({
      title: this.content.title
    })
  },
  methods: {
    async getData() {
      const slug = this.$route.params.slug
      const { data } = await useAsyncQuery(newsItemQuery, { slug })
      if(data.value) {
        this.content = toRaw(data.value.posts.data[0].attributes)
        if(this.content.content) {
          this.content.content = this.fixImageUrl(this.content.content)
          this.content.content = this.content.content.replace('<h2>', '<h2 class="font-h2">')
          this.content.content = this.content.content.replaceAll('<p>', '<p class="font-t-l">')
          this.content.content = this.content.content.replaceAll('<h4>', '<h4 class="font-h-l">')
          this.content.content = this.content.content.replaceAll('<li>', '<li class="font-t-l">')
        }
      } else {
        setTimeout(() => {
          this.getData()
        },10)
      }
    },
    fixImageUrl(content) {
      const config = useRuntimeConfig()
      let src = /src=\"[A-Za-z0-9_.-\/]+\"/g
      const urls = content.match(src)
      if (urls && urls.length) {
        for(const url of urls) {
          const urlParts = url.split('="')
          urlParts[1] = config.public.strapiUrl + urlParts[1]
          content = content.replace(url, urlParts.join('="'))
        }
      }
      return content
    },
    async getAllNews() {
      const { data } = await useAsyncQuery(newsQuery)
      if(data.value) {
        const newsContent = toRaw(toRaw(data.value).posts.data)
        this.sortedNewsContent = newsContent.sort((a, b) => new Date(b.attributes.published) - new Date(a.attributes.published))
        const news = this.sortedNewsContent.slice(0,4)
        this.additionalNews = news.filter(item => item.attributes.slug != this.content.slug)
        this.additionalNews.forEach(item => {
          item.attributes.link = item.attributes.slug
        })
        if(this.additionalNews.length > 3) this.additionalNews = this.additionalNews.slice(0, 3)
        this.index = this.sortedNewsContent.findIndex(item => item.attributes.slug == this.content.slug)
        this.isFirst = this.index === 0
        this.isLast = this.index === this.sortedNewsContent.length - 1
      } else {
        setTimeout(() => {
          this.getAllNews()
        },10)
      }
    }
  }
}
</script>

<style lang="stylus">
.news-item
  &__content
    border-top 2px solid main-color007
    border-bottom 2px solid main-color007
    img:not(.news-card__image-body)
      width 100%
      margin-top 32px
    .news-card
      @media (min-width desktop-lower-limit)
        height auto
  &__navigation
    @media (min-width tablet-lower-limit)
      .rt-col-6
        border-right 1px solid main-color007
      .rt-col-6+.rt-col-6
        border-right none
        border-left 1px solid main-color007
    @media (max-width mobile-upper-limit)
      .rt-col-6
        position relative
        &:before
          position absolute
          content ''
          background-color main-color007
          height 1px
          left -10px
          right -10px
          bottom 0
      .rt-col-6+.rt-col-6
        &:before
          bottom auto
          top 0
  &__wrapper--hidden
    opacity 0

.news-item__wrapper
  li
    margin-top 20px
    position relative
    &:before
      content ""
      background-color b2c-slate
      left -17px
      position: absolute
      width 6px
      height 6px
      border-radius 50%
      top 9px
    &+&
      margin-top 16px
  a
    color b2c-slate
    transition color .2s linear
    @media (hover: hover)
      &:hover
        color #516F79
  ul
    list-style none


.nav-button
  min-width 100%
  cursor pointer
  @media (max-width mobile-upper-limit)
    justify-content space-between
    flex-direction row-reverse
  @media(hover: hover)
    &:hover
      span
        color #516F79
      svg path
        fill #516F79

.sticky
  position sticky
  top 100px
  @media (min-width desktop-lower-limit)
    margin-bottom -20px

.jc-fe
  @media (min-width tablet-lower-limit)
    justify-content flex-end
  @media (max-width mobile-upper-limit)
    flex-direction row

.news-item__wrapper
  p.font-t-l
    margin-top 28px
    @media (min-width tablet-upper-limit)
      margin-top 24px
</style>